import { render } from "./ModalSelectDiningOption.vue?vue&type=template&id=1d1c59f2&scoped=true"
import script from "./ModalSelectDiningOption.vue?vue&type=script&lang=js"
export * from "./ModalSelectDiningOption.vue?vue&type=script&lang=js"

import "./ModalSelectDiningOption.vue?vue&type=style&index=0&id=1d1c59f2&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1c59f2"]])

export default __exports__